import ApplicationFarmerDocumentService from '@/services/retailer/ApplicationFarmerDocumentService.js'
import ApplicationService from '@/services/retailer/ApplicationService.js'

import { errorMessage } from '@/utilities/helpers.js'

import { NOTIFICATION_TYPES, NOTIFICATION_SEVERITY_TYPES } from '@/constants/constants.js'
import { APPLICATION_ERROR_MESSAGES } from '@/constants/errorMessages.js'

export const namespaced = true

export const state = {
  waitingApplications: null,
  rejectedByOtherReasonApplications: null
}

export const mutations = {
  SET_WAITING_APPLICATIONS(state, applications) {
    state.waitingApplications = applications
  },
  SET_REJECTED_BY_OTHER_REASON_APPLICATIONS(state, applications) {
    state.rejectedByOtherReasonApplications = applications
  }
}

export const actions = {
  regeneratePin({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      ApplicationService.regeneratePin(params)
        .then(response => {
          const notification = {
            type: 'success',
            message: APPLICATION_ERROR_MESSAGES.regeneratePinError
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: NOTIFICATION_SEVERITY_TYPES.DANGER,
            message: errorMessage(err),
            kind: NOTIFICATION_TYPES.MODAL,
            preventReadEvent: true
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },

  getWaitingApplications({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      ApplicationService.getWaitingApplications()
        .then(response => {
          commit('SET_WAITING_APPLICATIONS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: APPLICATION_ERROR_MESSAGES.getWaitingApplicationsError
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },

  getRejectedByOtherReasonApplications({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      ApplicationService.getRejectedByOtherReasonApplications()
        .then(response => {
          commit('SET_REJECTED_BY_OTHER_REASON_APPLICATIONS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: APPLICATION_ERROR_MESSAGES.getRejectedByOtherReasonApplicationsError
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },

  uploadFarmerDocument({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      ApplicationFarmerDocumentService.uploadFarmerDocument(data.applicationId, data.formData)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },

  deleteFarmerDocument({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      ApplicationFarmerDocumentService.deleteFarmerDocument(data.applicationId, data.documentId)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
